import { initVideoControls } from '../ui/video_controls';

document.addEventListener('DOMContentLoaded', () => {
    initVideoControls();
});
